import * as React from 'react';
import { IgcGridToolbarAdvancedFilteringComponent as Component } from 'igniteui-webcomponents-grids/grids/index.js';
import { createComponent } from '../react-props.js';

/**
 * Provides a pre-configured button to open the advanced filtering dialog of the grid.
 */
export const IgrGridToolbarAdvancedFiltering = createComponent({
  tagName: 'igc-grid-toolbar-advanced-filtering',
  displayName: 'IgrGridToolbarAdvancedFiltering',
  elementClass: Component,
  react: React,
  moveBackOnDelete: true,
});

export type IgrGridToolbarAdvancedFiltering = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrGridToolbarAdvancedFilteringModule = Component;
